import { useState, useEffect } from 'react';
import { TouchIcon } from '../../modules/Icons';
import { SwipeHintProps } from '../../types/components/shared/SwipeHintTypes';

const SwipeHint: React.FC<SwipeHintProps> = ({show, onSwipe, switchDirection, className}) => {
  const [hasUserSwiped, setHasUserSwiped] = useState<boolean>(() => {
    return !!localStorage.getItem('hasUserSwiped');
  });

  useEffect(() => {
    if (hasUserSwiped) return;

    let touchStartX = 0;

    const handleTouchStart = (e: TouchEvent) => {
      touchStartX = e.touches[0].clientX;
    };

    const handleTouchEnd = (e: TouchEvent) => {
      const touchEndX = e.changedTouches[0].clientX;
      const deltaX = touchEndX - touchStartX;

      if (Math.abs(deltaX) > 50) {
        setHasUserSwiped(true);
        localStorage.setItem('hasUserSwiped', 'true');
        if (onSwipe) onSwipe();
      }
    };

    document.addEventListener('touchstart', handleTouchStart);
    document.addEventListener('touchend', handleTouchEnd);

    return () => {
      document.removeEventListener('touchstart', handleTouchStart);
      document.removeEventListener('touchend', handleTouchEnd);
    };
  }, [hasUserSwiped, onSwipe]);

  if (!show || hasUserSwiped) return null;

  return (
    <div cy-test-id="swipe-hint" className={className || "absolute inset-0 z-10 flex items-center justify-center"}>
      <div className={`relative flex items-center gap-3 px-6 py-3 rounded-full bg-black/40 ${switchDirection ? 'animate-container-slide-left' : 'animate-container-slide-right'}`}>
        <div className="flex items-center gap-2">
          <div className={`flex items-center gap-2 ${switchDirection ? 'animate-slide-left' : 'animate-slide-right'}`}>
            <TouchIcon className="text-white" />
            <span className="text-sm text-white whitespace-nowrap">Swipe to view more</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SwipeHint;